import type { BackfillExecutionDTOResponse } from '@/features/backfill/types/backfill.types.ts';

export const mapBackFillDTO = (data: BackfillExecutionDTOResponse) => {
  return {
    count: data.count,
    size: data.size,
    page: data.page,
    results: data.results.map(execution => ({
      id: execution.backfill_service_id,
      startTime: execution.start_time,
      endTime: execution.end_time,
      status: execution.status,
      failed_executions: execution.error_subjobs.map(job => ({
        startTime: job.batch_start_time,
        endTime: job.batch_end_time,
        errorMessage: job.error_message,
      })),
    })),
  };
};
